import { render, staticRenderFns } from "./SelfServiceBtnText.vue?vue&type=template&id=367a9019&scoped=true&"
import script from "./SelfServiceBtnText.vue?vue&type=script&lang=js&"
export * from "./SelfServiceBtnText.vue?vue&type=script&lang=js&"
import style0 from "./SelfServiceBtnText.vue?vue&type=style&index=0&id=367a9019&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367a9019",
  null
  
)

export default component.exports